const ATTRIBUTION_STORAGE_KEY = 'boulder_attribution';

const ATTRIBUTION_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'gclid',
  'gbraid',
  'wbraid',
  'fbclid',
  'msclkid',
  'ttclid',
] as const;

/**
 * Persists marketing attribution from the current URL so it remains available
 * during account creation on a later route.
 */
export function captureAttribution(search: string): void {
  const searchParams = new URLSearchParams(search);
  const attribution: Partial<Record<typeof ATTRIBUTION_PARAMS[number], string>> = {};

  ATTRIBUTION_PARAMS.forEach((key) => {
    const value = searchParams.get(key)?.trim();

    if (value) {
      attribution[key] = value;
    }
  });

  if (Object.keys(attribution).length === 0) {
    return;
  }

  try {
    window.localStorage.setItem(
      ATTRIBUTION_STORAGE_KEY,
      JSON.stringify({
        ...attribution,
        capturedAt: Date.now(),
      }),
    );
  } catch {
    // Attribution must not prevent navigation when browser storage is unavailable.
  }
}
